/**
 * Jetons d'appareil de confiance (2FA), un par adresse e-mail.
 *
 * Une map et pas une valeur unique : un poste de réception sert souvent à
 * plusieurs comptes, et chacun doit garder sa propre dispense de code.
 * Le stockage peut être indisponible (navigation privée) : on retombe alors
 * simplement sur la demande de code, jamais sur une erreur.
 */
import { readLocalStorage, writeLocalStorage } from '../hooks/useLocalStorageState';

const STORAGE_KEY = 'TF_TRUSTED_DEVICES';

function normalize(email: string): string {
    return email.trim().toLowerCase();
}

function readAll(): Record<string, string> {
    const stored = readLocalStorage<unknown>(STORAGE_KEY, {});
    return stored && typeof stored === 'object' ? (stored as Record<string, string>) : {};
}

export function getTrustedDeviceToken(email: string): string | null {
    return readAll()[normalize(email)] ?? null;
}

export function saveTrustedDeviceToken(email: string, token: string): void {
    writeLocalStorage(STORAGE_KEY, { ...readAll(), [normalize(email)]: token });
}

export function forgetTrustedDeviceToken(email: string): void {
    const map = readAll();
    delete map[normalize(email)];
    writeLocalStorage(STORAGE_KEY, map);
}

/**
 * Un jeton d'appareil a été envoyé et le serveur demande quand même le code :
 * il est expiré ou révoqué, inutile de le renvoyer à chaque connexion. (À
 * l'enrôlement, le serveur ne l'a pas jugé : on le garde.)
 */
export function forgetTrustedDeviceTokenIfRejected(
    email: string,
    sentToken: string | null,
    twoFactorMode: 'challenge' | 'enroll',
): void {
    if (sentToken && twoFactorMode === 'challenge') {
        forgetTrustedDeviceToken(email);
    }
}
